import { getDateTimeFromIso } from './helpers';
import { Folder } from '../../types';

export const FETCH_FOLDERS_LIMIT = 50;

export interface APSV1Folder {
  createdAt: string;
  createdBy: string;
  id: string;
  name: string;
  path: string[] | null;
  updatedAt: string;
  updatedBy: string;
  userCreatedAt: string;
}

export interface GetFoldersV1Response {
  data: APSV1Folder[];
  pagination: {
    limit: number;
    nextUrl: string | null;
    offset: number;
    totalResults: number;
  };
}

const translateResponse = (folderPages: GetFoldersV1Response[]) => {
  type FolderKeyMappingRecord = {
    [K in keyof APSV1Folder]: string;
  };
  const folderKeyMapping: FolderKeyMappingRecord = {
    createdAt: 'created_at',
    createdBy: 'created_by',
    id: 'uid',
    name: 'name',
    path: 'path',
    updatedAt: 'updated_at',
    updatedBy: 'updated_by',
    userCreatedAt: 'userCreatedAt',
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, spellcheck/spell-checker
  const valueMapping: Record<string, (apsValue: any) => any> = {
    created_at: getDateTimeFromIso,
    updated_at: getDateTimeFromIso,
    path: (oldValue: string[] | null) => {
      return oldValue ? oldValue.join('.') : null;
    },
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cacaFolders = folderPages.reduce((folders: any[], folderPage) => {
    return folders.concat(
      folderPage.data.map((folder) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const cacaFolder: Record<string, any> = { type: 'folder' };
        Object.entries(folder).forEach(([key, value]) => {
          const newKey =
            folderKeyMapping[key as unknown as keyof FolderKeyMappingRecord] ||
            key;
          const newValue = valueMapping[newKey]
            ? valueMapping[newKey]?.(value)
            : value;

          if (newValue !== null) {
            cacaFolder[newKey] = newValue;
          }
        });

        // Add required fields
        if (folder.path) {
          cacaFolder.parent_uid = folder.path[folder.path.length - 1];
        }

        return cacaFolder as Folder;
      }),
    );
  }, []);

  return { documents: cacaFolders };
};

const getFoldersTransformers = {
  translateResponse,
};

export default getFoldersTransformers;
